function logCartContents() {
	// Fetch the cart data using Shopify's Cart API
	fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			console.log('Cart Contents:', cart);
			// Optional: Log more specific details about the cart
			console.log('Total Items:', cart.items.length);
			console.log('Total Price:', cart.total_price / 100); // Shopify price is in cents
		})
		.catch(error => console.error('Error fetching cart:', error));
}

// Function to add a product to the cart

function addToCart(productId, quantity = 1) {
	const addToCartUrl = '/cart/add.js';

	// Get the Designer's Choice description if available
	const designersChoiceNote = document.getElementById('designers-choice-description')?.value || '';

	const data = {
		id: productId,
		quantity: quantity,
		properties: {
			'Customer Notes': designersChoiceNote, // Custom product note
		},
	};

	fetch(addToCartUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: JSON.stringify(data),
	})
		.then(response => {
			if (response.status === 422) {
				return response.json().then(error => {
					throw new Error(`Error 422: ${error.message}`);
				});
			}
			return response.json();
		})
		.then(cart => {
			console.log('Product added to cart:', cart);
			toggleCart(); // Open cart
			updateCartUI(); // Refresh UI
		})
		.catch(error => {
			console.error('Error adding to cart:', error);
			alert('An error occurred while adding the product to the cart.');
		});
}

function updateCartUI() {
	fetch(document.URL)
		.then(response => response.text())
		.then(data => {
			var parser = new DOMParser();
			var doc = parser.parseFromString(data, 'text/html');
			var newCartContent = doc.querySelector('#cart').innerHTML;
			document.querySelector('#cart-wrapper #cart').innerHTML = newCartContent;
		})
		.catch(error => console.error('Error loading content:', error));

	console.log('update cart ui');
}

window.onload = function() {
	document.getElementById('cart-form').addEventListener('submit', function(event) {
		event.preventDefault(); // Prevent the default form submission

		const formData = new FormData(this); // Get the form data

		fetch('/cart', {
			method: 'POST',
			body: formData, // Submit the form data as a POST request
		})
			.then(response => response.json()) // Parse the response as JSON
			.then(data => {
				// Handle the response, e.g., updating the cart without a page reload
				console.log(data);
				updateCartUI(); // Update the cart interface
			})
			.catch(error => {
				console.error('Error updating cart:', error);
			});
	});
	console.log('working.');
};

// Function to add a product to the cart
function BuyNow(productId, quantity = 1) {
	// Shopify add to cart API URL
	const addToCartUrl = '/cart/add.js';

	// Ensure quantity defaults to 1 if not provided
	quantity = quantity || 1;

	// Create the data object to send
	const data = {
		id: productId, // The product variant ID
		quantity: quantity, // Number of items to add
	};

	// Send AJAX request to Shopify cart
	fetch(addToCartUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: JSON.stringify(data),
	})
		.then(response => response.json())
		.then(cart => {
			window.location.href = '/checkout';
			// Optionally update the UI to reflect cart changes
		})
		.catch(error => {
			console.error('Error adding to cart:', error);
		});
}

//

// Function to remove a product from the cart
function removeFromCart(productId) {
	const updateCartUrl = '/cart/update.js';

	const data = {
		updates: {
			[productId]: 0, // Set the quantity to 0 to remove the product by its variant ID
		},
	};

	fetch(updateCartUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: JSON.stringify(data),
	})
		.then(response => response.json())
		.then(cart => {
			console.log('Product removed from cart:', cart);
			// 2. Update the cart UI
			updateCartUI();
		})
		.catch(error => {
			console.error('Error removing from cart:', error);
		});
}

function toggleCart() {
	const cartWrapper = document.getElementById('cart-wrapper');
	cartWrapper.classList.toggle('hidden');
}

// Close cart when clicking outside of #cart
document.getElementById('cart-wrapper').addEventListener('click', function(event) {
	const cart = document.getElementById('cart');
	if (!cart.contains(event.target)) {
		toggleCart();
	}
});

function toggleMenu() {
	const menu = document.getElementById('mobile-menu');
	menu.classList.toggle('hidden');
}

// ------ SUBSCRIPTION PRODUCTS ----------- //

// Function to subscribe to a product
function subscribe() {
	const addToCartUrl = '/cart/add.js';

	const data = {
		id: document.getElementById('variant-selection').value, // The product variant ID
		quantity: 1, // Number of items to add
		selling_plan: document.getElementById('selling_plan').value, // Selling plan ID for the subscription
	};

	// Send AJAX request to add the subscription to the cart
	fetch(addToCartUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: JSON.stringify(data),
	})
		.then(response => response.json())
		.then(cart => {
			window.location.href = '/checkout';
		})
		.catch(error => {
			console.error('Error subscribing to product:', error);
			alert('An error occurred while subscribing. Please try again.');
		});
}

function chooseProductOption(variantID, variantPrice, variantImage) {
	console.log(variantID);

	// First, remove the "selected-border" class from all elements with the "product-option" class
	const allOptions = document.querySelectorAll('.product-option');
	allOptions.forEach(option => {
		option.classList.remove('selected-product-option');
		console.log('removed');
	});

	// Find the parent element that corresponds to the selected variant
	const selectedOption = document.querySelector(`[data-variant-id="${variantID}"]`);

	console.log(selectedOption);

	// Add the "selected-border" class to the found child element
	if (selectedOption) {
		selectedOption.classList.add('selected-product-option');
	}

	let variantSelected = document.getElementById('variant-selection');
	variantSelected.value = variantID;

	// Update Price

	document.getElementById('product-price').innerText = variantPrice;

	// Update Image

	document.getElementById('main-image').src = variantImage;
}

// Adjust Item quantity in Cart

// Function to increase quantity of a product in the cart
function increaseQuantity(productId) {
	const updateCartUrl = '/cart/update.js';

	fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			const item = cart.items.find(item => item.id === productId);
			if (item) {
				const newQuantity = item.quantity + 1;

				const data = {
					updates: {
						[productId]: newQuantity,
					},
				};

				fetch(updateCartUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: JSON.stringify(data),
				})
					.then(response => response.json())
					.then(updatedCart => {
						console.log('Quantity increased:', updatedCart);
						updateCartUI(); // Optionally refresh UI
					})
					.catch(error => console.error('Error updating quantity:', error));
			} else {
				console.error('Product not found in cart');
			}
		})
		.catch(error => console.error('Error fetching cart:', error));
}

// Function to decrease quantity of a product in the cart
function decreaseQuantity(productId) {
	const updateCartUrl = '/cart/update.js';

	fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			const item = cart.items.find(item => item.id === productId);
			if (item && item.quantity > 0) {
				// Ensure quantity does not go below 1
				const newQuantity = item.quantity - 1;

				const data = {
					updates: {
						[productId]: newQuantity,
					},
				};

				fetch(updateCartUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: JSON.stringify(data),
				})
					.then(response => response.json())
					.then(updatedCart => {
						console.log('Quantity decreased:', updatedCart);
						updateCartUI(); // Optionally refresh UI
					})
					.catch(error => console.error('Error updating quantity:', error));
			} else {
				console.error('Product not found in cart');
			}
		})
		.catch(error => console.error('Error fetching cart:', error));
}

// Set Price Designers Choice

function setPriceDC(variantid, variantprice) {
	alert(variantid + ' ' + variantprice);
}
